import { useState } from "react";
import { Show, useRecordContext, useRedirect } from "react-admin";
import { Tabs, Tab, Box } from "@mui/material";

//Common styles
import {
  SectionTitleRow,
  TabsContainer,
  WorkspaceContainer,
  WorkspaceHeader,
  WorkspaceTitle,
} from "../../styles/commonStyles";

//Svg
import { CuisineIcon } from "../Svg/CuisineIcon";

//Common colors
import { colors } from "../../styles/colors";

//Components
import DishCategoryTagMetaShow from "./DishCategoryTagMetaShow";
import DishCategoryTagDishesTab from "./DishCategoryTagDishesTab";

const StatusBadge = ({ isActive }: { isActive: boolean }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      padding: "4px 10px",
      borderRadius: "999px",
      fontSize: "12px",
      fontWeight: 600,
      textTransform: "uppercase",
      backgroundColor: isActive ? "rgba(46, 125, 50, 0.12)" : "rgba(211, 47, 47, 0.12)",
      color: isActive ? "#2E7D32" : "#D32F2F",
    }}
  >
    {isActive ? "Active" : "Inactive"}
  </Box>
);

const DishCategoryTagShowHeader = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <WorkspaceHeader>
      <SectionTitleRow>
        <div
          style={{
            backgroundColor: "rgba(25, 117, 210, 0.1)",
            padding: "12px",
            borderRadius: "12px",
          }}
        >
          <CuisineIcon color={colors.primary} />
        </div>
        <div>
          <WorkspaceTitle>{record.name}</WorkspaceTitle>
        </div>
      </SectionTitleRow>

      <StatusBadge isActive={!!record?.isActive} />
    </WorkspaceHeader>
  );
};

const DishCategoryTagTabShow = ({ activeTab, setActiveTab, onUpdate }: any) => {
  const record = useRecordContext();

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <TabsContainer>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Details" />
          <Tab label="Dishes" />
        </Tabs>
      </TabsContainer>

      <br />

      {activeTab === 0 && <DishCategoryTagMetaShow onUpdate={onUpdate} />}
      {activeTab === 1 && <DishCategoryTagDishesTab tagId={Number(record?.id)} />}
    </>
  );
};

const DishCategoryTagShow = (props: any) => {
  const [activeTab, setActiveTab] = useState(0);
  const redirect = useRedirect();

  return (
    <WorkspaceContainer>
      <Show
        {...props}
        actions={false}
        sx={{
          backgroundColor: "transparent",
          "& .RaShow-card": { backgroundColor: "transparent", boxShadow: "none" },
        }}
      >
        <DishCategoryTagShowHeader />
        <DishCategoryTagTabShow
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onUpdate={(record: any) => redirect("edit", "DishCategoryTag", record.id)}
        />
        <br />
      </Show>
    </WorkspaceContainer>
  );
};

export default DishCategoryTagShow;
